import { observer } from 'mobx-react-lite'
import { ProfileMenu } from '@/features/shell/global-navigation/Sidebar/ProfileMenu'
import { type GlobalNavigationViewModel } from '@/features/shell/global-navigation/GlobalNavigationViewModel'

export interface ProfileMenuContainerProps {
  vm: GlobalNavigationViewModel
}

export const ProfileMenuContainer = observer(function ProfileMenuContainer({
  vm,
}: ProfileMenuContainerProps) {
  return (
    <ProfileMenu
      visible={vm.profileMenu.showing}
      onRequestClose={vm.profileMenu.close}
      avatar={{
        avatar: vm.member.avatar,
        avatarFallback: vm.member.avatarFallback,
        displayName: vm.member.displayName,
      }}
      displayName={vm.member.displayName}
      email={vm.member.email}
      shouldShowBilling={vm.shouldShowBilling}
      canEnrollInMultiFactorAuth={vm.canEnrollInMultiFactorAuth}
      onEnrollInMultiFactorAuth={vm.enrollInMultiFactorAuth}
      onAddNewWorkspace={vm.addNewWorkspace}
      isFirmAdmin={vm.isFirmAdmin}
      isPro={vm.isPro}
    />
  )
})
